
/*
      ##    #######   ##     ##  ########   ########   ##    ##
      ##   ##     ##  ##     ##  ##         ##     ##   ##  ##
      ##   ##     ##  ##     ##  ##         ##     ##    ####
      ##   ##     ##  ##     ##  ######     ########      ##
##    ##   ##  ## ##  ##     ##  ##         ##   ##       ##
##    ##   ##    ##   ##     ##  ##         ##    ##      ##
 ######     ##### ##   #######   ########   ##     ##     ##
*/

$(document).ready(function() {

	$('.ec_timeline_body').width( $('.ec_timeline_months').length * 240 );

	$('.espace-client-gallery').each(function(){
		$(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			tLoading: "Chargement de l'image #%curr%...",
			mainClass: 'mfp-img-mobile',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0,1], // Will preload 0 - before current, and 1 after the current image
				tCounter: '%curr% sur %total%'
			}
		});
		$(this).on('click', function(){
			$(this).find('a:first-of-type').trigger('click');
		});
	});

	$('.ec_showroom_list_image').each(function(){
		$(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			tLoading: "Chargement de l'image #%curr%...",
			mainClass: 'mfp-img-mobile',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0,1], // Will preload 0 - before current, and 1 after the current image
				tCounter: '%curr% sur %total%'
			}
		});
	});

	var filter_service = $("select[name='filter_service']").select2({
		language:                "fr",
		placeholder:             'Trier par',
		containerCssClass:       'select2_filter',
		allowClear:              true,
		minimumResultsForSearch: 10
	});

	filter_service.on('select2:select', function(e){
		var val = e.params.data.id;
		$('[data-service]').hide();
		$('[data-service="'+val+'"]').show();
	});

	filter_service.on('select2:unselecting', function(e){
		$('[data-service]').show();
	});

	$(".ec_timeline_container").mousewheel(function(event, delta) {
		this.scrollLeft -= (delta * 10);
		event.preventDefault();
	});

	if( $(".ec_timeline_months--current").length > 0 ){
		$(".ec_timeline_container").scrollLeft(240);
	}

});
